import ConfigProvider, { ConfigConsumer, withConfigConsumer } from './provider';

export default ConfigProvider;
export { ConfigConsumer, withConfigConsumer };
